import { useEffect, useCallback, useState } from 'react';
import { Modal, Typography, Button } from 'antd';
import TerritoryService from 'services/territorio';
import CsvDownloader from 'react-csv-downloader';
import xlsIcon from 'assets/img/formats/xls.png';
import pdfIcon from 'assets/img/formats/pdf.png';
import csvIcon from 'assets/img/formats/csv.png';
import jsonIcon from 'assets/img/formats/json.png';
import Utils from 'utils';
import moment from 'moment';
import {
  faFilePdf,
  faFileExcel,
  faFileCode,
  faFileLines
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../css/_reportHead.scss';
const { Title } = Typography;
function ReportHead({ date, headerFunction, setLoading, setHeaderFunction }) {
  const [visibleDetails, setVisibleDetails] = useState(false);
  const [visibleVariables, setVisibleVariables] = useState(false);

  const downloadHeaders = ["Variabile", "Descrizione", "Note", "Fonte", "Link"];

  const fetchHeader = async (date, funzione) => {
    return await TerritoryService.header(date, funzione);
  };

  const headerVariables = useCallback(
    (formattedData) => {
      return (
        <>
          <div className="territorial-units-download d-flex justify-content-end align-items-center">
            <Button
              className="button-istat-svgpath"
              size="large"
              title="Scarica tabella report in PDF"
              aria-label="Scarica tabella report in PDF"
              icon={
                <FontAwesomeIcon
                  style={{ width: '27px', height: '27px' }}
                  icon={faFilePdf}
                  size="2xl"
                />
              }
              onClick={() =>
                Utils.exportPDF(
                  'Legenda ' +
                    headerFunction.titolo_report +
                    ' Data stampa ' +
                    moment().format('DD/MM/YYYY'),
                  [
                    { title: downloadHeaders[0] },
                    { title: downloadHeaders[1] },
                    { title: downloadHeaders[2] },
                    { title: downloadHeaders[3] },
                    { title: downloadHeaders[4] },
                  ],
                  formattedData.map((obj) => [obj.variabile, obj.note, obj.guida, obj.fonte, obj.link]),
                  'portrait'
                )
              }></Button>
            <Button
              className="button-istat-svgpath"
              title="Scarica tabella report in XLSX"
              aria-label="Scarica tabella report in XLSX"
              icon={
                <FontAwesomeIcon
                  style={{ width: '27px', height: '27px' }}
                  icon={faFileExcel}
                  size="2xl"
                />
              }
              onClick={() =>
                Utils.exportXLSX(
                  'Legenda report ' +
                    headerFunction.titolo_report +
                    ' Data stampa ' +
                    moment().format('DD/MM/YYYY'),
                  downloadHeaders,
                  formattedData.map(({ note, variabile, guida, fonte, link }) => ({
                    variabile,
                    guida,
                    note,
                    fonte,
                    link
                  }))
                )
              }></Button>
            <CsvDownloader
              title="Scarica tabella report in CSV"
              aria-label="Scarica tabella report in CSV"
              filename={
                'Legenda report ' +
                headerFunction.titolo_report +
                ' Data stampa ' +
                moment().format('DD/MM/YYYY')
              }
              columns={[
                {
                  id: 'cell1',
                  displayName: downloadHeaders[0]
                },
                {
                  id: 'cell2',
                  displayName: downloadHeaders[1]
                },
                {
                  id: 'cell3',
                  displayName: downloadHeaders[2]
                },
                {
                  id: 'cell4',
                  displayName: downloadHeaders[3]
                },
                {
                  id: 'cell5',
                  displayName: downloadHeaders[4]
                }
              ]}
              datas={formattedData.map(({ variabile, guida, note, fonte, link }) => ({
                cell1: variabile,
                cell2: guida,
                cell3: note,
                cell4: fonte,
                cell5: link
              }))}>
              <Button
                className="button-istat-svgpath"
                tabIndex="-1"
                icon={
                  <FontAwesomeIcon
                    style={{ width: '27px', height: '27px' }}
                    icon={faFileLines}
                    size="2xl"
                  />
                }></Button>
            </CsvDownloader>
            <Button
              className="button-istat-svgpath"
              title="Scarica tabella report in JSON"
              aria-label="Scarica tabella report in JSON"
              icon={
                <FontAwesomeIcon
                  style={{ width: '27px', height: '27px' }}
                  icon={faFileCode}
                  size="2xl"
                />
              }
              onClick={() => {
                const fileData = JSON.stringify(formattedData);
                const blob = new Blob([fileData], { type: 'text/plain' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.download =
                  'Legenda report ' +
                  headerFunction.titolo_report +
                  moment().format('DD_MM_YYYY HHmmss') +
                  '.json';
                link.href = url;
                link.click();
              }}></Button>
          </div>
          <div className="w-100 mb-4 descrizioneReport">{headerFunction?.descrizione_report}</div>
          <div className="reportHeadMain">
            <h2 className="variabiliTitle">Variabili</h2>
                  {formattedData.map((obj) => (
                <a aria-label="Apri pop-up dettaglio">
                  <div tabIndex="0"
                  onClick={() => {
                      Modal.info({
                      tabIndex: 0,
                      title: 'Dettagli',
                      visible: visibleDetails,
                      closable: true,
                      centered: true,
                      width: 800,
                      autoFocusButton: null,
                      onCancel: () => setVisibleDetails(false),
                      content: detailContent(obj),
                      okButtonProps: {
                        style: { backgroundColor: '#426F80', border: 0, borderRadius: '5px' }
                      },
                      okText: 'Chiudi',
                      onOk: () => setVisibleDetails(false)
                    });
                    setTimeout(
                      () => document.getElementsByClassName('ant-modal-wrap')[0].scrollTo(0, 0),
                      100
                    );
                  }}
                  className="headerVariable mt-4"
                  key={obj.variabile}>
                  <h3>{obj.variabile}</h3>
                  <p>{obj.guida}</p>
                </div>
              </a>
            ))}
          </div>
        </>
      );
    },
    [headerFunction, visibleDetails]
  );

  useEffect(() => {
    let unmounted = false;
    if (headerFunction && !unmounted) {
      setLoading(true);
      fetchHeader(date?.replaceAll('/', '-'), headerFunction.id_funzione)
        .then(({ data }) => {
          const labelArray = data.label.split('§');
          const formattedData = labelArray.map((label, i) => {
            const fonte = data.fonte.split('§')[i].trim();
            const guida = data.guida.split('§')[i].trim();
            const link = data.link.split('§')[i].trim();
            const note = data.note.split('§')[i].trim();
            const obj = { variabile: label.trim(), note, link, guida, fonte };
            return obj;
          });
          setLoading(false);
          const titleFinish = (
            <Title className="reportHeadH1">{headerFunction.titolo_report}</Title>
          );
            Modal.info({
            tabIndex: -1,
            title: titleFinish,
            closable: true,
            visible: visibleVariables,
            centered: true,
            autoFocusButton: null,
            width: 800,
            onCancel: () => {
              setVisibleVariables(false);
              setHeaderFunction();
            },
            content: headerVariables(formattedData),
                okButtonProps: {
                    style: { backgroundColor: '#426F80', border: 0, borderRadius: '5px' },
            },
            okText: 'Chiudi',
            onOk: () => {
              setVisibleVariables(false);
              setHeaderFunction();
            }
          });
        })
        .catch(() => setLoading(false));
    }

    return () => {
      unmounted = true;
    };
  }, [headerFunction, date, visibleVariables, headerVariables, setHeaderFunction, setLoading]);

  const detailContent = (obj) => (
    <div className="territory-variable-detail">
      <div>
        <div className="detail-title">Variabile</div>
        <div>{obj.variabile}</div>
      </div>
      <div>
        <div className="detail-title">Note</div>
        <div>{obj.note}</div>
      </div>
      <div>
        <div className="detail-title">Fonte</div>
        <div>{obj.fonte}</div>
      </div>
      <div>
        <div className="detail-title">Link</div>
        <div>{obj.link ? obj.link : 'Non presente'}</div>
      </div>
    </div>
  );

  return <></>;
}

export default ReportHead;
